import type { Flow } from '../../constants';

export interface Sale {
  dateTime: IsoString;
  amount: Amount;
  apiOptions?: ApiOptions[];
  card: Card;
  clerk: Clerk;
  // customer: Customer;
  transaction: Transaction;
}

export interface SaleRequest {
  amount: Amount;
  card: Card;
  // customer: Customer;
  transaction: Transaction;
  invoice: string;
  flow: Flow;
}

export enum RefundReason {
  WrongTicket = 'Purchased the wrong ticket',
  TripCancellation = 'Trip cancellation or schedule change',
  AccidentalPurchase = 'Accidental purchase',
  Other = 'Other (fill in the blank)',
}

export interface RefundRequest {
  amount: Amount;
  card: Card;
  transaction: {
    invoice: string;
    notes: string;
  };
  flow: Flow;
}

export interface CardVerifyRequest {
  expirationDate: string;
  card: Card;
}

export interface CardIdentifyRequest {
  dateTime: IsoString;
  card: CardIdentify;
}

interface CardIdentify {
  number: string;
  expirationDate: number;
  securityCode: SecurityCode;
}

export enum CardType {
  AX = 'AX',
  AP = 'AP',
  BC = 'BC',
  CI = 'CI',
  DB = 'DB',
  GC = 'GC',
  JC = 'JC',
  MC = 'MC',
  NS = 'NS',
  PL = 'PL',
  SC = 'SC',
  VS = 'VS',
  WP = 'WP',
  YC = 'YC',
}

type ApiOptions = string[];

export type IsoString =
  `${number}-${string}-${string}T${string}:${string}:${string}.${string}${
    | '+'
    | '-'}${string}:${string}`;

interface Transaction {
  source: string;
  invoice: string;
  notes: string;
  purchaseCard: PurchaseCard;
}

interface PurchaseCard {
  customerReference?: string;
  destinationPostalCode?: string;
  productDescriptors: string[];
}

// interface Customer {
//   addressLine1: string;
//   firstName: string;
//   lastName: string;
//   postalCode: string;
// }

interface Clerk {
  numericId: number;
}

interface Card {
  expirationDate: number;
  present: string;
  token: Token;
}

interface Token {
  value: string;
}

interface SecurityCode {
  indicator: string;
  value: string;
}

interface Amount {
  tax: number;
  total: number;
}

export interface Void {
  invoice: string;
}
